export enum FiUserSettingType {
    OnboardingVisitsCount = 0,
    DontShowFormReportOnboardingMessage = 1,
    DontShowNewQuickSelectionMessage = 2,
}
